export const FlagMarker = `
    <svg width="30" height="36" xmlns="http://www.w3.org/2000/svg"
        viewBox="0, 0, 30, 36">
        <defs>
            <linearGradient id="a" gradientUnits="userSpaceOnUse"
                x1="15" x2="15" y2="34.5">
            <stop offset="0" stop-color="#FFF" stop-opacity="0"></stop>
            <stop offset="1" stop-opacity=".25"></stop>
            </linearGradient>
        </defs>
        <ellipse cx="15" cy="34" rx="7.661" ry="2" opacity=".2"></ellipse>
        <path d="M25.6 4.4C22.9 1.7 19.1 0 15 0S7.1 1.7 4.4 4.4C1.7 7.1 0 10.9
            0 15s1.7 7.9 4.4 10.6C7.1 28.3 15 34.5 15 34.5s7.9-6.2
            10.6-8.9C28.3 22.9 30 19.1 30 15s-1.7-7.9-4.4-10.6z">
        </path>
        <path d="M25.6 4.4C22.9 1.7 19.1 0 15 0S7.1 1.7 4.4 4.4C1.7 7.1 0 10.9
            0 15s1.7 7.9 4.4 10.6C7.1 28.3 15 34.5 15 34.5s7.9-6.2
            10.6-8.9C28.3 22.9 30 19.1 30 15s-1.7-7.9-4.4-10.6z"
            fill="url(#a)"></path>
        <circle class="innerCircle" cx="15" cy="15" r="12" fill="none">
        </circle>
    </svg>
    <div style="position: absolute; top: 0px; left: 0px;
        width: 30px; height: 30px; background-image: none;">
        <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 30 30">
            <path fill="white" d="M285.81 179.765a11.96 11.96 0 0 0-8.483-3.513
                11.97 11.97 0 0 0-8.486 3.514 11.962 11.962 0 0 0-3.51 8.486c0
                3.315 1.344 6.316 3.517 8.488 2.17 2.17 8.482 7.112 8.482
                7.112s6.312-4.943 8.484-7.115a11.962 11.962 0 0 0 3.515-8.485
                11.97 11.97 0 0 0-3.518-8.487zM22.957 13.3L13.03
                8.53v9.535zM11.71
                7.674c.01-1.144-1.99-1.202-1.99-.096v16.207h1.986"></path>
        </svg>
    </div>
`;

export const ArrowMarker = '<?xml version="1.0"?><svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36px" height="36px">    <path d="M 12.115234 2 C 11.762234 2 11.411422 2.1846875 11.232422 2.5546875 L 3.0976562 20.580078 C 2.7726563 21.270078 3.3052344 22 3.9902344 22 C 4.1042344 22 4.2218438 21.979547 4.3398438 21.935547 L 12 18.9375 L 19.669922 21.933594 C 19.789922 21.978594 19.908438 22 20.023438 22 C 20.698438 22 21.225297 21.281609 20.904297 20.599609 L 13 2.5566406 C 12.822 2.1856406 12.468234 2 12.115234 2 z M 12 5.7148438 L 12 16.789062 L 11.998047 16.789062 L 11.271484 17.074219 L 5.9296875 19.166016 L 12 5.7148438 z"/></svg>';
